// SpecialListings.js
import React, { useState } from "react";
import useAkiyaSearchHook from "./useAkiyaSearchHook";
import Properties_listing from "./SpecialListings/Listings";

function SpecialListings() {
    const { headingData } = useAkiyaSearchHook();
    const [propertyCount, setPropertyCount] = useState(0);

    // Callback to receive property count from Properties_listing
    const handlePropertyCountChange = (count) => {
        setPropertyCount(count);
    };

    return (
        <>
            {/* Responsive Header */}
            <div className="mt-2 sm:mt-[10px] mb-3 sm:mb-[12px]">
                {headingData && headingData[0] && (
                    <div className="ml-0 font-bold text-lg sm:text-xl md:text-2xl lg:text-[26px] leading-tight">
                        <h2 className="dark-header">Hand picked high grade property on sale</h2>
                    </div>
                )}
            </div>

            {/* Responsive Container */}
            <div className="w-full flex mb-6 sm:mb-10 px-2 sm:px-0">
                <div className="w-full ml-4 sm:ml-[30px]">
                    <Properties_listing onPropertyCountChange={handlePropertyCountChange} />
                </div>
            </div>
        </>
    );
}


export default SpecialListings;